import LoadingButton from "@mui/lab/LoadingButton";
import { Avatar, Box, Button, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { isBrowser, isMobileOnly, isTablet } from "react-device-detect";
import { abbreviateNumber, icon, IMAGE_RESIZE_PATH, isNullOrEmpty, SELLER, STORE_BUCKET_NAME, StoreStats, USER_BUCKET_NAME, UserStats, WEBSITE_PATH, windowPostMessage } from "../../common/common";
import { resource } from "../../common/resource";
import { ReceiverDetailsContext } from "../../contexts/receiverDetailsContext";

interface ChatNullSetProps {
  warningRef: any;
  showWarning: boolean;
  adminIsBlocked: boolean;
  blockedAccount: boolean;
  updateFollowStatus: any;
}

const ChatNullset = ({ warningRef, showWarning, adminIsBlocked, blockedAccount, updateFollowStatus }: ChatNullSetProps) => {
  const { receiverDetails, setReceiverDetails } = useContext<any>(ReceiverDetailsContext);
  const { name, displayUsername, profilePhotoColor, profilePhoto, followers, posts, status } = receiverDetails;
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const followClicked: any = useRef<boolean>(false);

  const onFollowBackClick = () => {
    setIsLoading(true);
    followClicked.current = true;
    setReceiverDetails((prevReceiverDetails: any) => {
      if (prevReceiverDetails) {
        prevReceiverDetails.followers = receiverDetails.followers + 1;
      }
      return prevReceiverDetails;
    });
    windowPostMessage({ type: "refresh" }, WEBSITE_PATH);
    updateFollowStatus(2);
  };
  const onFollowClick = () => {
    if (blockedAccount) {
      windowPostMessage({ type: "snackMsg", snackMsg: resource.cannotFollow }, WEBSITE_PATH);
    } else if (adminIsBlocked) {
      windowPostMessage({ type: "snackMsg", snackMsg: resource.privacyMessage }, WEBSITE_PATH);
    } else {
      setIsLoading(true);
      followClicked.current = true;
      setReceiverDetails((prevReceiverDetails: any) => {
        if (prevReceiverDetails) {
          prevReceiverDetails.followers = receiverDetails.followers + 1;
        }
        return prevReceiverDetails;
      });
      updateFollowStatus(1);
    }
    windowPostMessage({ type: "refresh" }, WEBSITE_PATH);
  };
  const onViewProfileClick = () => {
    windowPostMessage({ url: displayUsername, type: "redirectNewTab", entityType: receiverDetails.entityType }, WEBSITE_PATH);
  };
  useEffect(() => {
    if (followClicked.current) {
      warningRef.current && warningRef.current.showFollowingWarning();
      followClicked.current = false;
    } else {
      warningRef.current && warningRef.current.resetWarning();
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiverDetails]);
  return (
    <Box className={`chatNullset ${!showWarning ? "showWarning" : ""} w-per-100 display-flex flex-direction-column display-flex-justify-center mdc-typography--border bor-t-r-b-l-4 pad-16`}>
      <Box className="w-per-100 display-flex flex-direction-column display-flex-justify-center">
        {!receiverDetails || (receiverDetails.entityType == 1 && !receiverDetails.usercodenum) ? (
          <Box className="box-56 bor-rad-50 bg-ultra-light-gray mdc-typography--border display-flex-justify-center"></Box>
        ) : adminIsBlocked || isNullOrEmpty(receiverDetails) || (!isNullOrEmpty(receiverDetails) && isNullOrEmpty(receiverDetails.name)) ? (
          <Box className="box-56 bor-rad-50 bg-light-gray mdc-typography--border display-flex-justify-center">{icon({ iconName: `${receiverDetails.entityType === 2 ? "storefront" : "person"}`, iconColor: "icon-true-white", iconSize: "size-32" })}</Box>
        ) : (
          <Avatar alt={name} sx={{ bgcolor: profilePhotoColor, width: "56px", height: "56px", fontSize: "32px" }} className="mdc-typography--border" src={`${IMAGE_RESIZE_PATH}${receiverDetails.entityType === 2 ? STORE_BUCKET_NAME : USER_BUCKET_NAME}/${profilePhoto};preset=250`} />
        )}
        <Typography variant="subtitle1" noWrap className="w-per-100 text-align-center mar-t-8 text-primary">
          {adminIsBlocked || isNullOrEmpty(receiverDetails) || (!isNullOrEmpty(receiverDetails) && isNullOrEmpty(receiverDetails.name)) ? "Account not found" : name}
        </Typography>
        {displayUsername ? (
          <Typography variant="body2" noWrap className="w-per-100 text-align-center text-secondary mar-t-4">
            @{displayUsername}
          </Typography>
        ) : null}
        <Box className="mar-t-8 flex flex-direction-row align-items-center">
          <Typography variant="subtitle2" className="text-primary">{`${adminIsBlocked ? 0 : followers ? abbreviateNumber(followers) : 0}`}</Typography>
          <Typography variant="body2" className="text-secondary mar-l-4">{`${followers === 1 ? "Follower" : "Followers"}`}</Typography>
          <div className="bg-light-gray bor-t-r-b-l-4 box-8 mar-l-8 mar-r-8"></div>
          <Typography variant="subtitle2" className="text-primary">{`${adminIsBlocked ? 0 : posts ? abbreviateNumber(posts) : 0}`}</Typography>
          <Typography variant="body2" className="text-secondary mar-l-4">{`${posts === 1 ? "Post" : "Posts"}`}</Typography>
        </Box>
        {!SELLER && receiverDetails.followingStatus === UserStats.USER_IS_FOLLOWING && (
          <LoadingButton className="mar-t-12 small-btn" variant="contained" loading={isLoading} disabled={isLoading} size="small" onClick={onFollowBackClick}>
            Follow back
          </LoadingButton>
        )}
        {(!SELLER && receiverDetails.entityType === 1 && receiverDetails.followingStatus === UserStats.NEITHER_USER_IS_FOLLOWING) || (!SELLER && receiverDetails.entityType === 2 && receiverDetails.followingStatus === StoreStats.NEITHER_USER_IS_FOLLOWING) ? (
          <LoadingButton className="mar-t-12 small-btn" variant="contained" loading={isLoading} disabled={isLoading} size="small" onClick={onFollowClick}>
            Follow
          </LoadingButton>
        ) : null}
        {SELLER && status !== 1 && !adminIsBlocked ? (
          <Button className="mar-t-12 small-btn" variant="contained" size="small" onClick={onViewProfileClick}>
            View profile
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default ChatNullset;

interface porops {
  header: string;
  body: string;
}
export const FollowersNullSet = ({ header, body }: porops) => {
  return (
    <Box className="null-set-container-1">
      <Box className="w-per-100 ht-48 display-flex-justify-center">
        <Typography variant={`${isBrowser ? "h6" : "subtitle1"}`} className={`text-align-center text-primary ${isTablet ? "ft-18" : ""}`}>
          {header}
        </Typography>
      </Box>
      <Box className="w-per-100 mar-t-16 ht-48 display-flex-justify-center">
        <Typography variant={`${!isMobileOnly ? "body1" : "body2"}`} className="text-align-center text-secondary">
          {body}
        </Typography>
      </Box>
    </Box>
  );
};
